import { defineFcm } from '../shared/factory';

export const FCM_NONPROFIT_CLAIM_ENABLED = defineFcm('nonprofit_claim_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-dolphin',
		scope: 'corgi-front-end',
		context: 'Nonprofit Claim Flow',
		description: 'Controls access to the nonprofit claim page.',
	});
